import { useDialogState } from '@user/utils/useDialogState'

export function useData() {
  const [open, setOpen, onClose] = useDialogState()

  return { open, setOpen, onClose } as const
}

export type UseData = ReturnType<typeof useData>
